export default function PolicyManagementController(
  $scope,
  $q,
  alerts,
  editEndnotesDialog,
  newRecommendedChangesDialog,
  documentSchemaChangedDialog,
  editPmDocumentDialog,
  loaderService,
  pmChangeLogDialog,
  orgDataService,
  vmDataService,
  pmDataService,
  pmSharedModelService,
  policyManagementSettingsDialog,
  serviceIds,
  ssDialogService,
  userService,
  $rootScope,
) {
  const vm = this;

  vm.groupId = 34;
  vm.eulaAccepted = true;
  vm.appIsLoaded = false;
  
  vm.loaderService = loaderService;

  vm.activeDocument = null;
  vm.completedDocuments = [];

  vm.handleAddDocumentClick = _handleAddDocumentClick;
  vm.handleEditEndnotesClick = _handleEditEndnotesClick;
  vm.handleViewChangeLogClick = _handleViewChangeLogClick;
  vm.handleEditSettingsClick = _handleEditSettingsClick;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleAddDocumentClick($event) {
    loaderService.showViewLoader = true;
    pmSharedModelService.allowNewAssessment().then((isAllowed) => {
      if (!isAllowed) {
        loaderService.showViewLoader = false;
        return alerts.warning('Only one Active Document allowed at a time.');
      }
      const dfdGetSettings = pmDataService.getSettings();
      const dfdGetDeniedChanges = vm.activeDocument
        ? pmDataService.getDeniedMasterDocumentChanges(vm.activeDocument.policyDocumentId)
        : $q.defer().resolve();
      const dfdGetPreviousDoc = pmDataService.getPolicyDocument(0);
      $q.all([
        dfdGetSettings,
        dfdGetDeniedChanges,
        dfdGetPreviousDoc,
      ]).then((responses) => {
        loaderService.showViewLoader = false;
        const settings = responses[0].data;

        if (responses[1]) {
          const deletedSectionIds = responses[1].data.masterSectionDeleted;
          const createdSectionIds = responses[1].data.masterSectionCreated;

          if ((createdSectionIds && createdSectionIds.length) || (deletedSectionIds && deletedSectionIds.length)) {
            const deletedSections = _extractTokenizedMasterSectionsById(deletedSectionIds);
            const addedSections = _extractTokenizedMasterSectionsById(createdSectionIds);

            return _showDocumentSchemaChangedDialog($event, {
              document: {
                policyDocumentId: 0,
              },
              settings,
              deletedSections,
              addedSections,
            });
          }
        }

        let includeAppendixElectronicBanking = false;
        let includeAppendixSocialMedia = false;
        let includeAppendixAcceptableUsePolicy = false;
        let includeAppendixRemoteDepositCapture = false;
        let includeAppendixRemoteAccessPolicy = false;
        let includeSSVendorRiskAssessmentText = false;
        let includeSocialMediaPolicyText = false;

        if (responses[2]) {
          includeAppendixElectronicBanking = responses[2].data.includeAppendixElectronicBanking;
          includeAppendixSocialMedia = responses[2].data.includeAppendixSocialMedia;
          includeAppendixAcceptableUsePolicy = responses[2].data.includeAppendixAcceptableUsePolicy;
          includeAppendixRemoteDepositCapture = responses[2].data.includeAppendixRemoteDepositCapture;
          includeAppendixRemoteAccessPolicy = responses[2].data.includeAppendixRemoteAccessPolicy;
          includeSSVendorRiskAssessmentText = responses[2].data.includeSSVendorRiskAssessmentText;
          includeSocialMediaPolicyText = responses[2].data.includeSocialMediaPolicyText;
        }

        return _showEditDocumentDialog($event, {
          document: {
            policyDocumentId: 0,
            includeAppendixElectronicBanking,
            includeAppendixSocialMedia,
            includeAppendixAcceptableUsePolicy,
            includeAppendixRemoteDepositCapture,
            includeAppendixRemoteAccessPolicy,
            includeSSVendorRiskAssessmentText,
            includeSocialMediaPolicyText,
          },
          settings,
        });
      });
    });
  }

  function _extractTokenizedMasterSectionsById(sectionIds) {
    return sectionIds.length
      ? sectionIds.map(
        (masterSectionId) => {
          const masterSectionCopy = pmSharedModelService.masterDocumentSections.find(
            masterSection => masterSection.masterDocumentSectionId === masterSectionId
          );
          return {
            ...masterSectionCopy,
            tokenizedBody: pmSharedModelService.replaceTokens(masterSectionCopy.body),
          };
        }
      ) : [];
  }

  function _handleViewChangeLogClick($event) {
    loaderService.showViewLoader = true;
    return pmDataService.getChangeLogByCustomer().then(
      // Success
      (getChangeLogResponse) => {
        loaderService.showViewLoader = false;
        return _showChangeLogDialog($event, {
          policyDocumentId: null,
          changeLogItems: getChangeLogResponse.data,
          isNavantaUser: vm.isNavantaUser
        });
      },
      // Failure
      () => {
        loaderService.showViewLoader = false;
        alerts.error('There was an error fetching the Change Log');
      }
    );

    // return _showChangeLogDialog($event, {
    //   changeLogItems: _getChangeLogTestData(),
    // });
  }

  function _handleEditSettingsClick($event) {
    loaderService.showViewLoader = true;
    $q.all([
      pmDataService.getVariables(),
      pmDataService.getSettings(),
    ]).then((variablesResponse) => {
        loaderService.showViewLoader = false;
        const variables = variablesResponse[0].data.result;
        const settings = variablesResponse[1].data.result;
        return _loadEditSettingsDialog($event, [], variables, settings);
    });
  }

  function _handleEditEndnotesClick($event) {
    loaderService.showViewLoader = true;
    if (!vm.activeDocument) {
      alerts.error('There must be an Active Document to view End Notes.');
      loaderService.showViewLoader = false;
      return Promise.resolve();
    }
    return pmSharedModelService.getEndnotes(vm.activeDocument.policyDocumentId).then((endnotes) => {
      loaderService.showViewLoader = false;
      return _showEditEndnotesDialog($event, {
        endnotes,
        permissions: vm.permissions,
        policyDocumentId: vm.activeDocument.policyDocumentId,
      });
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    _initPermissions();
    _initEventListeners();
    _initUser();
    _initPolicyManagement().then(() => {
      _checkForNewRecommendations();
      vm.appIsLoaded = true;
    });
  }

  function _checkForNewRecommendations() {
    if (vm.combinedNewRecommendedChanges && vm.combinedNewRecommendedChanges.length > 0) {
      _showNewRecommendedChangesDialog({
        newChanges: vm.combinedNewRecommendedChanges,
        changedIds: pmSharedModelService.changedSections,
        isNew: true,
        changesAreRecommended: true,
      });
    }
  }

  function _showNewRecommendedChangesDialog(locals) {
    ssDialogService.dialogs.pm.newRecommendedChangesDialog = ssDialogService.alert(
      newRecommendedChangesDialog.getOptions(null, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.newRecommendedChangesDialog);
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('policyManagement').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on('refreshPMDocuments', _refresh);
    $scope.$on('pmShowEditEndnotesDialog', _showEditEndnotesDialog);
    $scope.$on('refreshPMDocumentsAfterSync', () => {
      _refresh(true);
    });
    $scope.$on('activeDocumentDeleted', (event, opt) => {
      if (vm.activeDocument) {
        // eslint-disable-next-line no-empty
        if (opt.policyDocumentId === vm.activeDocument.policyDocumentId) {
          vm.activeDocument = null;
        }
      }
    });

    $scope.$on('activeDocumentApproved', (event, opt) => {
      if (vm.activeDocument) {
        // eslint-disable-next-line no-empty
        if (opt.policyDocumentId === vm.activeDocument.policyDocumentId) {
          vm.activeDocument = null;
        }
      }
    });
  }

  function _initUser() {
    return orgDataService.getIsNavantaUser().then((response) => {
      vm.isNavantaUser = response.data.result;
    });
  }

  function _checkVariablesCompleted(emptyVariables, variables) {
    loaderService.showViewLoader = false;
    if (!emptyVariables || emptyVariables.length < 1 || !vm.permissions.canEditSettings) {
      return null;
    }
    return _loadEditSettingsDialog(null, emptyVariables, variables);
  }

  function _loadEditSettingsDialog($event, emptyVariables = [], variables = [], settings) {
    loaderService.showViewLoader = true;
    const promises = [
      orgDataService.getSelectableUsers(),
      vmDataService.getVendorsByCustomer(vm.customerId),
    ];

    return $q.all(promises).then((response) => {
        _showEditSettingsDialog($event, {
          variables,
          emptyVariables,
          settings,
          users: response[0].data.result,
          vendors: response[1].data.result,
        });
        loaderService.showViewLoader = false;
      });
  }

  function _initPolicyManagement() {
    return pmSharedModelService.initPolicyManagement()
      .then((result) => {
        loaderService.showViewLoader = false;
        vm.hasActiveDocuments = false;
        vm.customerId = result.customerId;
        vm.activeDocument = result.documents.activeDocument;
        pmSharedModelService.flattenedActiveDocumentSections = [];
        if (vm.activeDocument) {
          vm.hasActiveDocuments = true;
          vm.activeDocument.policyDocumentSections.forEach((section) => {
            pmSharedModelService.flattenedActiveDocumentSections = [
              ...pmSharedModelService.flattenedActiveDocumentSections,
              ..._getFlattenedChildrenSections(section)
            ];
          });
        }
        vm.completedDocuments = result.documents.completedDocuments;
        vm.hasCompletedDocuments = ((vm.completedDocuments !== null) && (vm.completedDocuments.length > 0));
        pmSharedModelService.policyDocumentEndNotes = result.policyDocumentEndNotes;
        pmSharedModelService.masterDocumentSections = result.masterDocumentSections;
        pmSharedModelService.masterEndNotes = result.masterEndNotes;
        pmSharedModelService.changedSections = result.changedSections;
        vm.combinedNewRecommendedChanges = pmSharedModelService.getCombinedChangesFromChangeArrays(
          result.changedSections
        );
        _checkVariablesCompleted(result.emptyVariables, result.variables);
      });
  }

  function _getFlattenedChildrenSections(section) {
    let flattenedSections = [];
    const tempSection = {
      ...section,
      policyDocumentSectionChildren: undefined,
    };

    flattenedSections.push(tempSection);
    if (section.policyDocumentSectionChildren && section.policyDocumentSectionChildren.length) {
      section.policyDocumentSectionChildren.forEach((childSection) => {
        flattenedSections = [
          ...flattenedSections,
          ..._getFlattenedChildrenSections(childSection)
        ];
      });
    }

    return flattenedSections;
  }

  function _refresh(afterSync) {
    loaderService.showViewLoader = true;
    return pmSharedModelService.getPolicyDocuments()
      .then(({ activeDocument, completedDocuments }) => {
        loaderService.showViewLoader = false;
        vm.activeDocument = activeDocument;
        vm.hasActiveDocuments = (vm.activeDocument !== undefined);
        vm.completedDocuments = completedDocuments;
        vm.hasCompletedDocuments = (vm.completedDocuments && vm.completedDocuments.length > 0);
        retrieveFlattenDocument(afterSync);
        // eslint-disable-next-line no-empty
      });
  }

  function retrieveFlattenDocument(afterSync) {
    pmSharedModelService.flattenedActiveDocumentSections = [];
    if (vm.activeDocument) {
      vm.activeDocument.policyDocumentSections.forEach((section) => {
        pmSharedModelService.flattenedActiveDocumentSections = [
          ...pmSharedModelService.flattenedActiveDocumentSections,
          ..._getFlattenedChildrenSections(section)
        ];
      });
    }
    if (afterSync) {
      $rootScope.$broadcast('closeSyncDialog');
    }
  }

  function _showEditEndnotesDialog($event, locals) {
    ssDialogService.dialogs.pm.editEndnotesDialog = ssDialogService.alert(
      editEndnotesDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.editEndnotesDialog);
  }

  function _showEditSettingsDialog($event, locals) {
    ssDialogService.dialogs.pm.settingsDialog = ssDialogService.alert(
      policyManagementSettingsDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.settingsDialog);
  }

  function _showDocumentSchemaChangedDialog($event, locals) {
    ssDialogService.dialogs.pm.documentSchemaChangedDialog = ssDialogService.alert(
      documentSchemaChangedDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.documentSchemaChangedDialog);
  }

  function _showEditDocumentDialog($event, locals) {
    ssDialogService.dialogs.pm.editPmDocumentDialog = ssDialogService.alert(
      editPmDocumentDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.editPmDocumentDialog);
  }

  function _showChangeLogDialog($event, locals) {
    ssDialogService.dialogs.pm.changeLogDialog = ssDialogService.alert(
      pmChangeLogDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm.changeLogDialog);
  }
}

PolicyManagementController.$inject = [
  '$scope',
  '$q',
  'alerts',
  'editEndnotesDialog',
  'newRecommendedChangesDialog',
  'documentSchemaChangedDialog',
  'editPmDocumentDialog',
  'loaderService',
  'pmChangeLogDialog',
  'orgDataService',
  'vmDataService',
  'pmDataService',
  'pmSharedModelService',
  'policyManagementSettingsDialog',
  'serviceIds',
  'ssDialogService',
  'userService',
  '$rootScope'
];
